export const TOPICS = [
  { id: 'ai', label: 'AI', count: 412 },
  { id: 'markets', label: 'Markets', count: 387 },
  { id: 'policy', label: 'Policy', count: 256 },
  { id: 'climate', label: 'Climate', count: 198 },
  { id: 'tech', label: 'Tech', count: 348 },
  { id: 'design', label: 'Design', count: 142 },
  { id: 'science', label: 'Science', count: 167 },
  { id: 'startups', label: 'Startups', count: 221 },
  { id: 'crypto', label: 'Crypto', count: 156 },
  { id: 'media', label: 'Media', count: 178 },
  { id: 'health', label: 'Health', count: 203 },
  { id: 'geopolitics', label: 'Geopolitics', count: 245 },
  { id: 'sports', label: 'Sports', count: 312 },
  { id: 'culture', label: 'Culture', count: 187 },
  { id: 'books', label: 'Books', count: 89 },
  { id: 'nyc', label: 'NYC', count: 134 },
  { id: 'sf', label: 'SF Bay', count: 121 },
  { id: 'europe', label: 'Europe', count: 198 },
];
